export var CARD_VARIANT = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal'
};
export var HEADER_VARIANT = {
  STATIC: 'static',
  FLOAT: 'float'
};